export function formatBookingResponseKey(key: string): string {
  if (key === "whatsappMessage") return "WhatsApp message";
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
}

export function getBookingResponseStringMessages(response: unknown): string[] {
  if (!response || typeof response !== "object" || Array.isArray(response)) {
    return [];
  }

  return Object.entries(response as Record<string, unknown>)
    .filter(([, value]) => typeof value === "string" && value.trim().length > 0)
    .map(([key, value]) => `${formatBookingResponseKey(key)}: ${value}`);
}
